export const HasRoleQuery = ({ address, roles, match }) => ({
    queryKey: () => ['has-role', address, roles?.join(',')],
    queryFn: async (blockchainManagementService) => {
        if (roles.length === 0) {
            return true;
        }
        return await blockchainManagementService.hasRole(address, roles, match);
    },
});
//# sourceMappingURL=has-role.js.map